/**
 * 卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';
import { getLocalStorage } from '@/assets/js/storage';

class Main extends React.Component {

    componentDidMount() {
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        const { accountType } = userInfo;

        if (accountType == 'COMPANY') {
            this.props.history.replace({ pathname: '/home/user/agent' });
        } else {
            this.props.history.replace({ pathname: '/home/user/member' });
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
};

export default Main;